var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "px-5 flex-level" },
      [
        _vm.data.icon
          ? _c("CompassIcon", {
              staticClass: "mr-3",
              attrs: { type: "primary", size: "medium", icon: _vm.data.icon }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          [
            _vm._t(
              "title",
              [
                _c("span", { staticClass: "semibold gray-60" }, [
                  _vm._v(_vm._s(_vm.data.label))
                ])
              ],
              { data: _vm.data }
            )
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex-right fs-2" },
          [
            _vm.data.count > 3 && !_vm.allResult
              ? _c(
                  "a",
                  {
                    staticClass: "link fs-2",
                    attrs: { href: "javascript:;" },
                    on: { click: _vm.toggleSeeMore }
                  },
                  [_vm._v(_vm._s(_vm.labelSeeMore))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._t(
              "results",
              [
                _c("span", { staticClass: "grey ml-2" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$l10n.n__(
                        "%d résultat",
                        "%d résultats",
                        _vm.data.count,
                        _vm.data.count
                      )
                    )
                  )
                ])
              ],
              { data: { nbResult: _vm.data.count ? _vm.data.count : 0 } }
            )
          ],
          2
        )
      ],
      1
    ),
    _vm._v(" "),
    !_vm.groupBy.length
      ? _c(
          "ul",
          { staticClass: "my-1" },
          _vm._l(_vm.reducedResults, function(item, itemIndex) {
            return _c(
              "li",
              { key: itemIndex, staticClass: "hover-primary-05-bkg px-5 py-2" },
              [
                _c(
                  "a",
                  { staticClass: "pointer", attrs: { href: item.link } },
                  [_vm._t("content", null, { data: item })],
                  2
                )
              ]
            )
          }),
          0
        )
      : _c(
          "div",
          { staticClass: "my-2" },
          [
            _vm._l(_vm.groupBy, function(group) {
              return [
                _vm.groupedResults(group.key).length
                  ? _c("div", { key: group.key, staticClass: "mb-2" }, [
                      _c("span", { staticClass: "semibold ml-5" }, [
                        _vm._v(_vm._s(group.label))
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticClass: "mt-0" },
                        _vm._l(_vm.groupedResults(group.key), function(
                          item,
                          itemIndex
                        ) {
                          return _c(
                            "li",
                            {
                              key: itemIndex,
                              staticClass: "hover-primary-05-bkg px-5 py-2"
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "pointer",
                                  attrs: { href: item.link }
                                },
                                [_vm._t("content", null, { data: item })],
                                2
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  : _vm._e()
              ]
            })
          ],
          2
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }